import React, { memo } from 'react'

import { arrayOf, func, shape } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { imageShape } from 'Pods/ThreeDStudio/Shared/ImageModal/imageShape'

import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'

function SimilarImages({ images = EMPTY_ARRAY, onSelect = NOOP }) {
  const t = useTranslation()

  if (images.length === 0) return null

  return (
    <div className="image-gallery-modal__similar">
      <h3 className="image-gallery-modal__similar-title cgt-body-md-semibold">
        {t('imageGallery.modal.similarImages')}
      </h3>
      <ul className="image-gallery-modal__similar-grid">
        {images.map(image => (
          <li key={image.id} className="image-gallery-modal__similar-item">
            <button
              type="button"
              className="image-gallery-modal__similar-button"
              onClick={() => onSelect(image)}
              aria-label={t('imageGallery.card.open', { title: image.title })}
            >
              <img
                className="image-gallery-modal__similar-image"
                src={image.src}
                alt=""
                aria-hidden="true"
                loading="lazy"
                decoding="async"
              />
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}

SimilarImages.propTypes = {
  images: arrayOf(shape(imageShape)),
  onSelect: func,
}

export default memo(SimilarImages)
